/**
 * NewsHoverController
 * #news の .news-list__li にホバーすると、.news__thumbnail の画像を
 * その記事のアイキャッチ画像に差し替える。
 *
 * - リスト全体から離れたら初期画像(data-default-thumb)へ戻す
 * - チラつき防止のため、初期化時に全サムネイル URL をプリロード
 * - opacity で fade cross するため .is-fading を切替
 */
export const NewsHoverController = {
  init() {
    const section = document.querySelector( '#news' );
    if ( !section ) return;

    const list      = section.querySelector( '.news-list' );
    const wrapper   = section.querySelector( '.news__thumbnail' );
    const img       = wrapper?.querySelector( 'img' );
    if ( !list || !wrapper || !img ) return;

    const defaultSrc = wrapper.dataset.defaultThumb || img.src;
    const items      = list.querySelectorAll( '.news-list__li' );
    if ( !items.length ) return;

    // プリロード（ブラウザキャッシュに乗せておく）
    const preloaded = new Set();
    const preload   = ( src ) => {
      if ( !src || preloaded.has( src ) ) return;
      const p = new Image();
      p.src = src;
      preloaded.add( src );
    };
    preload( defaultSrc );
    items.forEach( ( item ) => preload( item.dataset.thumb ) );

    // フェード付きで src を差し替える
    // opacity 0 → src 差替 → opacity 1 という2段階
    const swap = ( nextSrc ) => {
      if ( !nextSrc || img.src === nextSrc ) return;
      img.style.opacity = '0';
      // トランジション終了を待たずに次フレームで src を差し替える。
      // プリロード済みなので即座に描画され、CSS の opacity 復帰でフェードイン。
      setTimeout( () => {
        img.src = nextSrc;
        img.style.opacity = '1';
      }, 150 );
    };

    items.forEach( ( item ) => {
      item.addEventListener( 'mouseenter', () => swap( item.dataset.thumb ) );
    } );
    list.addEventListener( 'mouseleave', () => swap( defaultSrc ) );
  },
};
